import { render, staticRenderFns } from "./ExtendableInfo.vue?vue&type=template&id=b84f4db8"
import script from "./ExtendableInfo.vue?vue&type=script&lang=js"
export * from "./ExtendableInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports